module.exports = __webpack_public_path__ + "static/media/aws_logo.13551526.png";